export default __webpack_public_path__ + "static/media/sana2.5b8ae07b.mp4";